import { memo } from 'react';
import { useIsRTL } from '../../../locale';
import { postfixTestId } from '../../../util/testId';
import cn from './SliderTrackTicks.css.json';
import './SliderTrackTicks.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SliderTrackTicks = /*#__PURE__*/memo(function SliderTrackTicks(props) {
  const isRTL = useIsRTL();
  return /*#__PURE__*/_jsx("div", {
    "data-testid": props.testId,
    className: cn.tickContainer[props.orientation],
    children: props.orientation === 'vertical' ? props.tickPositions.map((tickPos, index) => {
      return /*#__PURE__*/_jsx("div", {
        "data-testid": postfixTestId(props.testId, `tick${index}`),
        className: cn.tick[props.orientation],
        style: {
          top: `${(1 - tickPos) * 100}%`
        }
      }, index);
    }) : props.tickPositions.map((tickPos, index) => {
      return /*#__PURE__*/_jsx("div", {
        "data-testid": postfixTestId(props.testId, `tick${index}`),
        className: cn.tick[props.orientation],
        style: {
          right: isRTL ? `${tickPos * 100}%` : undefined,
          left: !isRTL ? `${tickPos * 100}%` : undefined
        }
      }, index);
    })
  });
});
//# sourceMappingURL=SliderTrackTicks.js.map